import { Abregler } from "../../../../types/api.types";

export const SLOT_DURATION_MS = 15 * 60 * 1000; // Timeslots from BE should always be 15 minutes

export const ABREGLER_LABELS: Record<Abregler, string> = {
  [Abregler.netzbetreiber]: "RD",
  [Abregler.direktvermarkter]: "DVA",
  [Abregler.betreiber]: "Betreiber"
};

export function getAbreglerLabel(
  abregler: Abregler | undefined | null
): string {
  if (!abregler) return "Unbekannt";
  return ABREGLER_LABELS[abregler];
}
